import React from "react";
import SoftBadge from "modules/common/SoftBadge";
import { Popover, Tag } from "antd";
import moment from "moment";
import { InfoCircleOutlined } from "@ant-design/icons";
import { currentUser, getCurrentUserRole } from "modules/utilities/utility";

function Tags({ item }) {
  const leadAgent = ["lead_agent"];

  const content = (record) => {
    return (
      <div>
        <p>
          <strong>Tracking ID</strong>:{" "}
          {record.tracking_id !== null ? record.tracking_id : "None"}
        </p>
        <p>
          <strong>Tracking URL</strong>:{" "}
          {record.tracking_url !== null ? record.tracking_url : "None"}
        </p>
      </div>
    );
  };
  return (
    <div>
      {(item?.single || item?.bulk) && (
        <SoftBadge className="m-1" bg="info">
          {item?.bulk && "B"}
          {item?.single && "SO"}
        </SoftBadge>
      )}
      {item?.isSlotBooked ? (
        <SoftBadge className="m-1" key={"slot_booking"} bg="warning">
          SLOT BOOKING
        </SoftBadge>
      ) : null}
      {(leadAgent.includes(currentUser)) ? (
        <SoftBadge className="mx-1" bg="info">
          <div>
            Booked At : {moment(item.createdAt).format("MMMM Do, YYYY")}
          </div>
        </SoftBadge>
      ) : null}
      {getCurrentUserRole() === "medical"
        ? item?.tags?.map((tag, index, array) =>
            index === 0 || index === array.length - 1 ? (
              tag === "NEW" ? (
                <SoftBadge className="m-1" key={index} bg="warning">
                  {tag}
                </SoftBadge>
              ) : tag.includes("cod") ||
                tag.includes("pre") ||
                tag.includes("RO") ? (
            <SoftBadge className="m-1 text-capitalize" key={index} bg="info">
                  {tag.replace("_", " ").replace("undefined", "")}
                </SoftBadge>
              ) : (
            <SoftBadge className="m-1 text-capitalize" key={index} bg="primary">
                  <span>{tag.replace("_", " ")}</span>
                  <span className="ms-1">
                    {item.delivery_date &&
                      moment(item.delivery_date).format("DD-MMM-YYYY")}
                  </span>
                </SoftBadge>
              )
            ) : null
          )
        : 
          item?.tags?.map((tag, index) =>
            tag === "NEW" ? (
              <SoftBadge className="m-1" key={index} bg="warning">
                {tag}
              </SoftBadge>
            ) : tag.includes("cod") ||
              tag.includes("pre") ||
              tag.includes("RO") ? (
              <SoftBadge className="m-1 text-capitalize" key={index} bg="info">
                {tag.replace("_", " ").replace("undefined", "")}
              </SoftBadge>
            ) : (tag.includes("Attempt") &&
              leadAgent.includes(currentUser)) ? null : (
              <div className="d-flex flex-row gap-2">
                <SoftBadge
                  className="m-1 text-capitalize"
                  key={index}
                  bg="primary"
                >
                  <span>{tag.replace("_", " ")}</span>
                  <span className="ms-1">
                    {item.delivery_date &&
                      moment(item.delivery_date).format("DD-MMM-YYYY")}
                  </span>
                </SoftBadge>
                {(tag == "SLOT_BOOKING" &&
                leadAgent.includes(currentUser) &&
                item?.unanswered_count) ? (
                  <SoftBadge bg="danger" className="m-1 text-capitalize">
                    <span className="text-nowrap">
                      Reattempt : {item?.unanswered_count}
                    </span>
                  </SoftBadge>
                ) : null}
              </div>
            )
          )}

      {
        <Popover placement="top" content={content(item)} trigger="click">
          <InfoCircleOutlined />
        </Popover>
      }
      {item.reschedule_count && item.reschedule_count !== null ? (
        <SoftBadge bg="warning">Rescheduled</SoftBadge>
      ) : (
        ""
      )}
    </div>
  );
}

export default Tags;
